import script from "./projection-status.vue?vue&type=script&lang=js&setup=true"
export * from "./projection-status.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__